module.exports = __webpack_public_path__ + "static/media/9.5622ef1a.jpg";